import { combineReducers } from 'redux';
import { HISTORY_LOG_ACTIVITY_REDUCER } from '../logActivity/redux';

export const HISTORY_REDUCER = combineReducers({
  LOG_ACTIVITY: HISTORY_LOG_ACTIVITY_REDUCER,
});
